<div
  class="tw-flex tw-items-center tw-gap-2 tw-py-2"
  [class]="{
    'tw-bg-neutral-100': isActive,
  }"
  [tabindex]="disableTabbing ? -1 : 0"
>
  <!-- The Apollo Avatar component requires the altText input. However, in the search item, 
   the profile image is purely decorative and does not need alt text.  -->
  <da-avatar
    [size]="avatarSize"
    [imageUrl]="profileImageUrl()"
    [altText]="''"
    aria-hidden="true"
    [fallbackIcon]="fallbackIcon()"
  ></da-avatar>
  <div class="tw-flex tw-flex-grow tw-flex-col">
    @if (item.name) {
      <h3
        class="tw-mr-1 tw-break-all tw-text-sm tw-font-semibold tw-text-neutral-800"
      >
        {{ item.name }}
      </h3>
    }

    @if (!isRemovable && (item.organizationEmail || item.email)) {
      <span class="tw-break-all tw-text-sm tw-text-neutral-800">{{
        item.organizationEmail || item.email
      }}</span>
    }
  </div>
  @if (isRemovable) {
    <button
      type="button"
      class="tw-btn-icon tw-btn-tertiary-neutral"
      [attr.aria-label]="
        translate('Remove User', 'A11y_RemoveUser', { userType: item.name })
      "
      (click)="onRemoveUser()"
    >
      <da-icon
        icon="x-mark"
        type="solid"
        [solidSize]="24"
        class="tw-size-6 tw-text-neutral-600"
      ></da-icon>
    </button>
  }
</div>
